import React, { useState } from 'react';
import { BarcodeScanner } from '../../components/BarcodeScanner';
import { Button } from '../../components/ui/button';

// Test page for BarcodeScanner component
// Access via /scanner-test route
export const ScannerTest = () => {
  const [scannerOpen, setScannerOpen] = useState(false);
  const [lastScannedCode, setLastScannedCode] = useState(null);
  const [scanHistory, setScanHistory] = useState([]);

  const handleScan = (code) => {
    console.log('[ScannerTest] Scanned code:', code);
    setLastScannedCode(code);
    setScanHistory(prev => [...prev, { code, timestamp: new Date().toISOString() }]);
  };

  const handleClose = () => {
    console.log('[ScannerTest] Scanner closed');
    setScannerOpen(false);
  };

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-2xl mx-auto space-y-6">
        <h1 className="text-3xl font-bold">BarcodeScanner Test Page</h1>
        <p className="text-muted-foreground">
          Test the BarcodeScanner component. Add ?debugScanner=1 to URL for diagnostics overlay.
        </p>
        
        <div className="flex gap-4">
          <Button 
            onClick={() => setScannerOpen(true)}
            data-testid="open-scanner-btn"
          >
            Open Scanner
          </Button>
        </div>
        
        {lastScannedCode && (
          <div className="p-4 bg-green-100 border border-green-300 rounded-lg">
            <p className="font-semibold">Last Scanned Code:</p>
            <p className="font-mono text-lg">{lastScannedCode}</p>
          </div>
        )}
        
        {scanHistory.length > 0 && (
          <div className="space-y-2">
            <h2 className="text-xl font-semibold">Scan History</h2>
            <div className="space-y-1">
              {scanHistory.map((item, idx) => (
                <div key={idx} className="p-2 bg-muted rounded text-sm font-mono">
                  {item.code} - {item.timestamp}
                </div>
              ))}
            </div>
          </div>
        )}
        
        <BarcodeScanner
          open={scannerOpen}
          onClose={handleClose}
          onScan={handleScan}
        />
      </div>
    </div>
  );
};

export default ScannerTest;
